<template>
  <div class="invitee">
    更多好菜，尽在舌尖英雄
  </div>
</template>

<script>

export default {
  name: 'Invitee',
  data: () => {
    return {

    }

  },
  
  mounted(){

  },
}
</script>

<style scoped lang="scss">

</style>
